// extracted by mini-css-extract-plugin
export var numberInputContainer = "_56-0";
export var startPickingButton = "_56-1";